import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiBankTransferData, type EnrollmentMultiBankTransferSubmitOutput } from '../../../../models'

export const getEnrollmentMultiBankTransferDataMock: EnrollmentMultiBankTransferData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/funding/bank-transfer',
  enrollmentData: {
    applicationId: '305802305',
  },
  complete: false,
}

export const submitEnrollmentMultiBankTransferDataMock: EnrollmentMultiBankTransferSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  enrollmentData: {
    applicationId: '305802305',
  },
  complete: true,
  path: '/enrollment/multi/funding/fund-success',
}

export const getEnrollmentMultiPlaidTokenMock: EnrollmentMultiBankTransferSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  complete: false,
  enrollmentData: {
    plaidLinkToken: 'plaid-link-token',
  },
}

export const mockGetEnrollmentMultiBankTransferData = graphql.mutation('getEnrollmentMultiBankTransferData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiBankTransferDataMock } })
})

export const mockGetEnrollmentMultiPlaidToken = graphql.mutation('getEnrollmentMultiPlaidToken', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiPlaidTokenMock } })
})

export const mockSubmitEnrollmentMultiBankTransferData = graphql.mutation(
  'submitEnrollmentMultiBankTransferData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiBankTransferDataMock } })
  },
)

export const mockEnrollmentMultiBankTransfer = [
  mockGetEnrollmentMultiBankTransferData,
  mockSubmitEnrollmentMultiBankTransferData,
  mockGetEnrollmentMultiPlaidToken,
]
